import request from '@/utils/request'

export const getdailypanel = (month) => {
    let url = 'api/v/daily'
    if(month){
        url = 'api/v/daily?month='+ month
    }
    return request({
        method: 'GET',
        url: url
    })
}